// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__9jeu6","buttons":"SendReceipts_buttons__tHxut","email":"SendReceipts_email__32Pls","bookApptTitle":"SendReceipts_bookApptTitle__2kJaQ"};